var _rect, _text, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 160,
    height: 160,
    fill: "#f0f0f0",
    rx: 20,
    ry: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 100,
    fontFamily: "Arial, sans-serif",
    fontSize: 80,
    fill: "#333",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Tc")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "#4a90e2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "white",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "123"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 140 Q50 180, 140 140",
    stroke: "#333",
    strokeWidth: 4,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1895dc080793d1b75ee0cd97ceeb62e0.svg";
export { ForwardRef as ReactComponent };